module.exports = __webpack_public_path__ + "static/Kuo_Toa-2ff0b56ce5b7f7104b0679acf05692e7.jpg";